import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/lora";
import "@fontsource-variable/golos-text";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
